import HealthLogo from "../../assets/img/healthlogo.svg";

type OrgAuthLayoutProp = {
  bgImage: any;
  children: any;
  title?: string;
};
const OrgAuthLayout: React.FC<OrgAuthLayoutProp> = ({ children, bgImage }) => {
  return (
    <>
      <div className="lg:block hidden z-20 bg-white w-full fixed pl-8 py-4 w-f transition cursor-pointer">
        <img src={HealthLogo} alt="HealthLogo" height="260" width="170" />
      </div>
      <main className={`relative transition bg-slate-100`}>
        <div className="flex h-screen screen-container bg-slate-100  overflow-hidden">
          <div className="lg:w-1/2 m-auto w-full">{children}</div>
          <div className="lg:w-1/2 lg:flex hidden items-end relative">
            <img
              src={bgImage}
              alt="bg_image"
              className="object-cover w-full"
              style={{ objectPosition: "center" }}
            />
          </div>
        </div>
      </main>
    </>
  );
};

export default OrgAuthLayout;
